import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  keyResults: Yup.array().of(
    Yup.object().shape({
      title: Yup.string().required('Key result is required'),
      metricName: Yup.string().required('Metric is required'),
      metricOperator: Yup.string().required('Operator is required'),
      targetValue: Yup.string().required('Target value is required'),
      weight: Yup.number()
        .required('Weight is required')
        .min(0, 'Weight must be positive')
        .max(100, 'Weight cannot exceed 100'),
    })
  ),
});
